import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import '../Styles/Header.css';

const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const token = localStorage.getItem('token');
    const userRole = localStorage.getItem('role');

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        navigate('/login');
    };

    // Array to hold the list items
    const navItems = [];

    // TODO: part of my attempt at trying to move the button to open the sidebar, to the header -Oliver
    // // only show this if they're logged in and on the view of HCWs page
    // if (token && location.pathname === "/viewofhcws") {
    //     // button to open sidebar
    //     navItems.push(
    //         <li key="close-sidebar">
    //             <FaTimes className="close-icon" onClick={toggleSidebar} />
    //         </li>
    //     );
    // }

    navItems.push(
        <li key="home">
            <Link to="/">Home</Link>
        </li>
    );

    // User-specific links while logged in
    if (token) {
        navItems.push(
            <li key="viewofhcws">
                <Link to="/viewofhcws">View Healthcare Workers</Link>
            </li>
        );
        navItems.push(
            <li key="resetpassword">
                <Link to="/resetpassword">Change Password</Link>
            </li>
        );
        navItems.push(
            <li key="chatoverview">
                <Link to="/chat-overview">Chats</Link>
            </li>
        );
    }

    // Different links for possibly a different kind of user
    // if (token && userRole === 'admin') {
    //     navItems.push(
    //         <li key="admin-dashboard">
    //             <Link to="/admin/dashboard">Admin Dashboard</Link>
    //         </li>
    //     );
    //     navItems.push(
    //         <li key="admin-settings">
    //             <Link to="/admin/settings">Admin Settings</Link>
    //         </li>
    //     );
    // }

    // Logout button only when logged in
    if (token) {
        navItems.push(
            <li key="logout" className="logout-container">
                <button onClick={handleLogout}>Logout</button>
            </li>
        );
    }

    return (
        <nav>
            <ul>{navItems}</ul>
        </nav>
    );
};

export default Header;
